import { MessageEntity } from "../entities/UIEntities/MessageEntity";
import { commonActions } from "../redux/reducers/CommonReducer";
import store from "../redux/Store";
import { LENGTHS } from "../config/Config";
import Icons from "../resources/icons/Icons";
import Strings from "../resources/Strings";
import { errorAction, reloadAction } from "./MenuUtils";

export const showAddParkerSuccessMessage = (siteDisplayName) => {
  const updateSuccessMessage = new MessageEntity(
      Icons.UPDATE_SUCCESS,
      Strings.TITLES.CREATE_SUCCESS,
      `${Strings.SUCCESSFULY_ADDED_PARKER}`.format(siteDisplayName),
      Strings.GREAT,
      "",
      closeMessageModal
    );
    store.dispatch(commonActions.setMessageModal(updateSuccessMessage));
};

export const showDeletedParkerSuccessMessage = () => {
  const updateSuccessMessage = new MessageEntity(
      Icons.UPDATE_SUCCESS,
      Strings.TITLES.DELETE_SUCCESS,
      Strings.SUCCESSFULY_DELETED_PARKER,
      Strings.GREAT,
      "",
      closeMessageModal
    );
    store.dispatch(commonActions.setMessageModal(updateSuccessMessage));
};

export const showDeletedChargeAccountSuccessMessage = () => {
  const updateSuccessMessage = new MessageEntity(
      Icons.UPDATE_SUCCESS,
      Strings.TITLES.DELETE_SUCCESS,
      Strings.SUCCESSFULY_DELETED_CHARGE_ACCOUNT,
      Strings.GREAT,
      "",
      closeMessageModal
    );
    store.dispatch(commonActions.setMessageModal(updateSuccessMessage));
};

export const showAddWorkspaceSuccessMessage = () => {
  const updateSuccessMessage = new MessageEntity(
      Icons.UPDATE_SUCCESS,
      Strings.TITLES.CREATE_SUCCESS,
      Strings.SUCCESSFULY_ADDED_WORKSPACE,
      Strings.GREAT,
      "",
      closeMessageModal
    );
    store.dispatch(commonActions.setMessageModal(updateSuccessMessage));
};

export const showAddBillingRuleSuccessMessage = () => {
  const updateSuccessMessage = new MessageEntity(
      Icons.UPDATE_SUCCESS,
      Strings.TITLES.CREATE_SUCCESS,
      Strings.SUCCESSFULY_ADDED_BILLING_RULE,
      Strings.GREAT,
      "",
      closeMessageModal
    );
    store.dispatch(commonActions.setMessageModal(updateSuccessMessage));
};

export const showDeletedBillingRuleSuccessMessage = () => {
  const updateSuccessMessage = new MessageEntity(
      Icons.UPDATE_SUCCESS,
      Strings.TITLES.DELETE_SUCCESS,
      Strings.SUCCESSFULY_DELETED_BILLING_RULE,
      Strings.GREAT,
      "",
      closeMessageModal
    );
    store.dispatch(commonActions.setMessageModal(updateSuccessMessage));
};

export const showUpdateSuccessMessage = () => {
    const updateSuccessMessage = new MessageEntity(
        Icons.UPDATE_SUCCESS,
        Strings.TITLES.UPDATE_SUCCESS,
        null, /* Strings.SUCCESSFULY_SAVE */
        Strings.GREAT,
        "",
        closeMessageModal
      );
      store.dispatch(commonActions.setMessageModal(updateSuccessMessage));
};

export const showValidateParkingSuccessMessage = () => {
  const updateSuccessMessage = new MessageEntity(
      Icons.UPDATE_SUCCESS,
      Strings.TITLES.VALIDATE_PARKING_SUCCESS,
      "",
      Strings.CLOSE,
      "",
      closeMessageModal
    );
    store.dispatch(commonActions.setMessageModal(updateSuccessMessage));
};

export const showSaveCampaignSuccessMessage = () => {
  const campaignSuccessMessage = new MessageEntity(
      Icons.UPDATE_SUCCESS,
      Strings.TITLES.SAVE_CAMPAIGN_SUCCESS,
      Strings.SUCCESSFULY_CAMPAIGN_SAVED,
      Strings.OK,
      "",
      closeMessageModal
    );
    store.dispatch(commonActions.setMessageModal(campaignSuccessMessage));
};

export const showSendCampaignSuccessMessage = () => {
  const campaignSuccessMessage = new MessageEntity(
      Icons.UPDATE_SUCCESS,
      Strings.TITLES.SEND_CAMPAIGN_SUCCESS,
      Strings.SUCCESSFULY_CAMPAIGN_SENT,
      Strings.OK,
      "",
      closeMessageModal
    );
    store.dispatch(commonActions.setMessageModal(campaignSuccessMessage));
};

export const showDiscardChangesMessage = () => {
  const discardChangesMessage = new MessageEntity(
      Icons.ERROR,
      Strings.TITLES.DISCARD_CHANGES,
      Strings.DISCARD_CHANGES_MESSAGE,
      Strings.IM_SURE,
      Strings.CANCEL,
      closeAllModals,
      closeMessageModal
    );
    store.dispatch(commonActions.setMessageModal(discardChangesMessage));
};

export const showInviteSuccessMessage = () => {
  const updateSuccessMessage = new MessageEntity(
      Icons.UPDATE_SUCCESS,
      Strings.TITLES.INVITATION_SUCCESS,
      Strings.SUCCESSFULY_INVITATION_SENT,
      Strings.GREAT,
      "",
      closeMessageModal
    );
    store.dispatch(commonActions.setMessageModal(updateSuccessMessage));
};

export const showInviteAssociatedErrorMessage = () => {
  const inviteErrorMessage = new MessageEntity(
    Icons.ERROR,
    Strings.TITLES.ERROR,
    Strings.MODAL_ERROR_MESSAGES.GMT_USER_EMAIL_ALREADY_EXISTS,
    Strings.TRY_AGAIN,
    null,
    closeMessageModal
  );
  store.dispatch(commonActions.setMessageModal(inviteErrorMessage));
}

export const showKioskLoginNameAlreadyExist = (error = null) => {
  const errorMessage = new MessageEntity(
    Icons.ERROR,
    error ? error.errorTitle : Strings.TITLES.ERROR,
    error ? error.errorDescription : `${Strings.MODAL_ERROR_MESSAGES.KIOSK_LOGIN_NAME_ALREADY_EXISTS}`,
    Strings.TRY_AGAIN,
    null,
    errorAction
  );
  store.dispatch(commonActions.setMessageModal(errorMessage));
};

export const showBillingRemainingTimeError = (error = null) => {
  const errorMessage = new MessageEntity(
    Icons.ERROR,
    error ? error.errorTitle : Strings.TITLES.ERROR,
    error ? error.errorDescription : `${Strings.MODAL_ERROR_MESSAGES.BILLING_REMAINING_TIME}`,
    Strings.TRY_AGAIN,
    null,
    errorAction
  );
  store.dispatch(commonActions.setMessageModal(errorMessage));
};

export const showPhoneNumberAlreadyExist = (error = null) => {
  const errorMessage = new MessageEntity(
    Icons.ERROR,
    error ? error.errorTitle : Strings.TITLES.ERROR,
    error ? error.errorDescription : `${Strings.MODAL_ERROR_MESSAGES.PARKER_PHONE_NUMBER_ALREADY_EXISTS}`,
    Strings.TRY_AGAIN,
    null,
    errorAction
  );
  store.dispatch(commonActions.setMessageModal(errorMessage));
};

export const showEmailAlreadyExist = (error = null) => {
  const errorMessage = new MessageEntity(
    Icons.ERROR,
    error ? error.errorTitle : Strings.TITLES.ERROR,
    error ? error.errorDescription : `${Strings.MODAL_ERROR_MESSAGES.PARKER_EMAIL_ALREADY_EXISTS}`,
    Strings.TRY_AGAIN,
    null,
    errorAction
  );
  store.dispatch(commonActions.setMessageModal(errorMessage));
};

export const showReachedTokensAssignLimitErrorMessage = (error = null) => {
  const errorMessage = new MessageEntity(
    Icons.ERROR,
    error ? error.errorTitle : Strings.TITLES.ERROR,
    error ? error.errorDescription : `${Strings.MODAL_ERROR_MESSAGES.REACHED_TOKENS_LIMIT}`.format(LENGTHS.MAX_ASSIGNED_NUMBER_PER_TOKEN_LENGTH),
    Strings.CONFIRM,
    null,
    errorAction
  );
  store.dispatch(commonActions.setMessageModal(errorMessage));
};

export const showMissingFieldsValueErrorMessage = (error = null) => {
  const errorMessage = new MessageEntity(
    Icons.ERROR,
    error ? error.errorTitle : Strings.TITLES.ERROR,
    error ? error.errorDescription : `${Strings.MODAL_ERROR_MESSAGES.FIELD_VALUE_IS_MISSING}`,
    Strings.TRY_AGAIN,
    null,
    errorAction
  );
  store.dispatch(commonActions.setMessageModal(errorMessage));
};

export const showCampaignErrorMessage = (error = null) => {
  const errorMessage = new MessageEntity(
    Icons.ERROR,
    error ? error.errorTitle : Strings.TITLES.ERROR,
    error ? error.errorDescription : "",
    Strings.TRY_AGAIN,
    null,
    errorAction
  );
  store.dispatch(commonActions.setMessageModal(errorMessage));
};

export const showMissingFobValueErrorMessage = (error = null) => {
  const errorMessage = new MessageEntity(
    Icons.ERROR,
    error ? error.errorTitle : Strings.TITLES.ERROR,
    error ? error.errorDescription : `${Strings.MODAL_ERROR_MESSAGES.FOB_VALUE_IS_MISSING}`,
    Strings.TRY_AGAIN,
    null,
    errorAction
  );
  store.dispatch(commonActions.setMessageModal(errorMessage));
};

export const showParkingAllocationSaveIsNotReadyMessage = (error = null) => {
  const errorMessage = new MessageEntity(
    Icons.ERROR,
    error ? error.errorTitle : Strings.TITLES.ERROR,
    error ? error.errorDescription : `${Strings.MODAL_ERROR_MESSAGES.FINISH_PROCESS}`,
    Strings.CONFIRM,
    null,
    errorAction
  );
  store.dispatch(commonActions.setMessageModal(errorMessage));
};

export const showLoginErrorMessage = (error = null) => {
  const errorMessage = new MessageEntity(
    Icons.ERROR,
    error ? error.errorTitle : Strings.SORRY,
    error ? error.errorDescription : `${Strings.MODAL_ERROR_MESSAGES.LOGIN_INVALID}`,
    Strings.TRY_AGAIN,
    null,
    errorAction
  );
  store.dispatch(commonActions.setMessageModal(errorMessage));
};

export const showNetworkErrorMessage = (error) => {
  const errorMessage = new MessageEntity(
    Icons.ERROR,
    Strings.TITLES.ERROR,
    error,
    Strings.CONFIRM,
    Strings.RELOAD,
    errorAction,
    reloadAction
  );
  store.dispatch(commonActions.setMessageModal(errorMessage));
};

export const showUpdateCarErrorMessage = (error = null) => {
  const errorMessage = new MessageEntity(
    Icons.ERROR,
    error ? error.errorTitle : Strings.TITLES.ERROR,
    error ? error.errorDescription : `${Strings.ERROR_MESSAGE}`,
    Strings.TRY_AGAIN,
    null,
    errorAction
  );
  store.dispatch(commonActions.setMessageModal(errorMessage));
};

export const showFetchUserDataErrorMessage = (error = null) => {
  const errorMessage = new MessageEntity(
    Icons.ERROR,
    error ? error.errorTitle : Strings.TITLES.ERROR,
    error ? error.errorDescription : `${Strings.ERROR_MESSAGE}`,
    Strings.TRY_AGAIN,
    null,
    errorAction
  );
  store.dispatch(commonActions.setMessageModal(errorMessage));
};

export const showErrorMessage = (error = null) => {
    const errorMessage = new MessageEntity(
      Icons.ERROR,
      error ? error.errorTitle : Strings.TITLES.ERROR,
      error ? error.errorDescription : `${Strings.ERROR_MESSAGE}`,
      Strings.CONFIRM,
      null,
      errorAction
    );
    store.dispatch(commonActions.setMessageModal(errorMessage));
  };


  export const closeMessageModal = () => {
    store.dispatch(commonActions.closeMessageModal());
  };

  export const closeAllModals = () => {
    store.dispatch(commonActions.closeMessageModal());
    store.dispatch(commonActions.closeSideModal());
  };
